import { Text } from '@react-email/components';
import { merge } from 'lodash';

const paragraph = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        const paragraphStyles = {
            style: {
                fontSize: undefined,
                lineHeight: undefined,
                margin: undefined,
            },
        };
        return (
            <Text
                {...attributes}
                {...merge(paragraphStyles, element.attributes)}
            >
                {children}
            </Text>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        const paragraphStyles = {
            style: {
                fontSize: undefined,
                lineHeight: undefined,
                margin: undefined,
            },
        };
        return <Text {...merge(paragraphStyles, attributes)}>{children}</Text>;
    },
};

export default paragraph;
